// Plan ▸ Corkboard: index cards for a folder's children, as a grid, freeform or swimlanes, with the heatmap.
export { Corkboard as component } from '../../views/Corkboard.tsx';
export { CorkboardControls as headerControls } from '../../views/plan/CorkboardControls.tsx';
export const room = 'plan';
export const page = 'corkboard';
export const title = 'Corkboard';
export const help = 'corkboard';
export const takesNode = true;
